// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
  position: relative;
}

.header-container .navtlbar {
  display: flex;
  justify-content: space-between;
  flex-flow: row nowrap;
  align-items: center;
}

.header-container .pageTitle-new {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.hamHeader a {
  text-decoration: none !important;
}

.menuHam {
  width: 30px;
  display: flex;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  color: #0078ab;
  cursor: pointer;
  height: 22px;
}

.menuHam span {
  opacity: 1;
  left: 0;
  cursor: pointer;
  border-radius: 3px;
  height: 3px;
  width: 100%;
  background-color: #0078ab;
  position: absolute;
  display: block;
  content: '';
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
  transition: all 0.25s ease-in-out;
}

.active.menuHam span {
  background-color: #fff;
}

.menuHam span:nth-child(1) {
  top: 0px;
}

.menuHam span:nth-child(2) {
  top: 9px;
}

.menuHam span:nth-child(3) {
  top: 18px;
}

.menuHam.active span:nth-child(1) {
  top: 7px;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.menuHam.active span:nth-child(2) {
  opacity: 0;
  right: -30px;
}

.menuHam.active span:nth-child(3) {
  top: 7px;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

.menuItemDisable {
  opacity: 0.5;
  cursor: default;
}

.navbar-nav > li > a {
  line-height: 50px;
}

.pageTitle.active {
  display: none;
}

.navbar-fixed-top {
  z-index: 999;
  background: #fff;
  height: 100px;
  width: 100%;
}

.navbar-fixed-top.active {
  z-index: 9999;
  color: #fff;
  background-color: #087dc3;
  transition: background-color 0.2s ease;
  height: 100px;
  width: 100%;
}

.navbar-collapse.collapse {
  display: block;
}

.navbar-brand {
  float: left;
  height: 50px;
  font-size: 18px;
  margin-left: 89px;
  margin-top: 5px;
  line-height: 20px;
}

.sidenav.collapseMenu {
  width: 0;
  transition: background-color 0.2s ease;
  z-index: 99999;
}

.ptbBody .ptbBkground.backdrop {
  z-index: 10000;
}

.sidenav.expandMenu {
  width: 100%;
  display: flex;
  height: calc(100vh - 85px);
  background-color: rgba(0, 121, 194, 0.97);
  transition: background-color 0.2s ease;
  visibility: visible;
  overflow-y: auto;
}

.sidenav {
  height: 100%;
  position: fixed;
  z-index: 9999;
  top: 100px;
  padding-top: 50px;
}

.menuTitle {
  margin-top: -11px;
  margin-left: 45px;
  font-size: 28px;
  color: #0078ab;
  font-family: 'Open Sans', sans-serif;
}

.active.menuHam .menuTitle {
  display: inline;
  margin-left: 48px;
  color: #fff;
}

.sidenav .nav_btn_conatiner a {
  color: #fff;
  font-size: 20px;
  display: block;
  text-decoration: none;
  -webkit-transition: 0.03ms;
  -moz-transition: 0.03ms;
  transition: 0.03ms;
  cursor: pointer;
}

.sidenav .nav_btn_conatiner a i {
  width: 60px;
  height: 65px;
  display: block;
  margin: 40px auto 0px;
}

.header-container .navbar .userInfo {
  display: none;
}

.pageTitle {
  text-align: center;
  width: 33.33333333333333%;
  float: left;
}

.menuHam-new {
  display: none;
}
.new-nav {
  border: 0;
  box-shadow: none;
  height: 120px;
}

.ant-bp-pagetitle {
  font-family: 'Open Sans';
  font-weight: normal;
  font-size: 32px;
  color: #0079c2;
  position: relative;
  margin-bottom: 0px;
  cursor: pointer;
}

.pageTitle img {
  width: 130px;
}

.active .pageTitle img {
  visibility: hidden;
}
.navtkbar {
  display: none;
}

.navtkbar {
  float: left;
  width: 33.33333333333333%;
}

.navtkbar ul {
  float: right;
  margin: 0;
}

.notify {
  float: left;
  list-style-type: none;
}
.notifyMsg {
  white-space: nowrap;
  width: 204px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notify .greetingMsg {
  font-size: 1.125em;
  text-transform: capitalize;
  top: 8px;
  position: relative;
  font-weight: normal;
}
.notify h5 {
  text-align: right;
  font-weight: 600;
  margin-top: 0.4em;
}

.notify a {
  border-radius: 50%;
  background-color: #0079c2;
  width: 41px;
  height: 41px;
  display: inline-block;
  text-align: center;
  border: 1px solid #0079c2;
  margin-left: 12px;
}

.notify a:hover {
  border: 1px solid #0079c2;
  background: #ffffff !important;
  text-decoration: none !important;
}

.notify a::before {
  content: '\\f0f3';
  font-size: 27px;
  color: #ffffff;
  font-family: FontAwesome;
  font-weight: normal;
  position: relative;
}

.notify a:hover::before {
  color: #0079c2;
}

.notify .fa {
  color: #fe5e3c;
  font-size: 15px;
  position: absolute;
  margin: 5px -12px;
}

.user {
  float: left;
  list-style-type: none;
}

.user a {
  border-radius: 50%;
  background-color: #0079c2;
  width: 41px;
  height: 41px;
  display: inline-block;
  text-align: center;
  border: 1px solid #0079c2;
  margin-left: 12px;
}

.user a:hover {
  border: 1px solid #0079c2;
  background: #ffffff !important;
  text-decoration: none !important;
}

.user a::before {
  /* content: '\\f007'; */
  font-size: 27px;
  color: #ffffff;
  /* font-family: FontAwesome; */
  font-weight: normal;
  position: relative;
}

.user a:hover:before {
  color: #0079c2;
}

.mobileSearch {
  float: left;
  list-style-type: none;
}

.mobileSearch a {
  border-radius: 50%;
  background-color: #0079c2;
  width: 41px;
  height: 41px;
  display: inline-block;
  text-align: center;
  border: 1px solid #0079c2;
  margin-left: 12px;
}

.mobileSearch a:hover {
  border: 1px solid #0079c2;
  background: #ffffff !important;
  text-decoration: none !important;
}

.mobileSearch a::before {
  content: '\\f002';
  font-size: 27px;
  color: #ffffff;
  font-family: FontAwesome;
  font-weight: normal;
  position: relative;
}

.mobileSearch a:hover:before {
  color: #0079c2;
}

@media screen and (max-width: 1177px) {
  .navbar {
    padding: 20px 40px 0px;
  }
}

@media screen and (max-width: 1024px) {
  .navbar {
    padding: 20px 0px 0 1px;
  }
  .new-nav {
    padding: 20px 40px 0px;
  }
}

@media screen and (max-width: 800px) {
  .sidenav {
    padding: 0px;
  }
  .active .navtkbar {
    display: block;
  }
  .menuTitle {
    display: none;
  }
}

@media (max-width: 1023px) and (min-width: 801px) {
  .menuTitle {
    display: none;
  }
}

@media screen and (min-width: 801px) {
  .navtkbar {
    display: block;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .active.menuHam .menuTitle {
    display: inline;
    margin-left: 48px;
    color: #fff;
  }
  .pageTitle img {
    width: 130px;
    transition: width 2s;
  }
}

@media screen and (max-width: 599px) {
  .menuHam-new {
    display: block;
    margin-right: 12px;
  }
  .active.menuHam-new span {
    background-color: #0079c2;
  }
  #app {
    top: 100px;
  }
  .new-nav {
    padding: 30px 10px 0px;
    height: 100px;
  }
  .greet {
    margin-bottom: 2px;
  }
}

@media only screen and (min-device-width: 600px) and (max-device-width: 768px) {
  .navtkbar {
    width: 66.3333333333333%;
  }
  .active.menuHam .menuTitle {
    display: none;
  }
}

@media only screen and (min-device-width: 525px) and (max-device-width: 600px) {
  .active .pageTitle {
    display: none;
  }
  .navtkbar {
    width: 66.3333333333333%;
    float: right;
  }
  .active.menuHam .menuTitle {
    display: none;
  }
}

@media only screen and (min-width: 525px) and (max-width: 875px) {
  .active .pageTitle {
    display: none;
  }
  .navtkbar {
    width: 38.3333333333333%;
    float: right;
  }
  .active.menuHam .menuTitle {
    display: none;
  }
  .pageTitle {
    width: auto;
  }
  .ant-bp-pagetitle {
    font-size: 32px;
  }
}

@media screen and (min-width: 375px) and (max-width: 525px) {
  .active .pageTitle {
    display: none;
  }
  .navtkbar {
    width: 66.3333333333333%;
    float: right;
  }
  .notify .greetingMsg {
    font-size: 1em;
  }
  .menuTitle {
    display: none;
  }
  .active.menuHam .menuTitle {
    display: none;
  }
  .pageTitle {
    width: auto;
  }
  .ant-bp-pagetitle {
    font-size: 24px;
    position: relative;
  }
}

@media screen and (max-width: 375px) {
  .active .pageTitle {
    display: none;
  }
  .notify .greetingMsg {
    font-size: 12px;
  }
  .notify h5 {
    font-size: 0.9em;
  }
  .navtkbar {
    width: 66.3333333333333%;
    float: right;
  }
  .menuTitle {
    display: none;
  }
  .active.menuHam .menuTitle {
    display: none;
  }
  .pageTitle {
    width: auto;
  }
  .ant-bp-pagetitle {
    font-size: 24px;
    position: relative;
  }
  .notifyMsg {
    width: 116px;
  }
}
@media screen and (max-width: 425px) {
  .small-icons a {
    width: 30px;
    height: 30px;
  }
  .small-icons a::before {
    font-size: 19px;
  }
}

/* Header Icons styles when the menu is active */

.active .notify a {
  border-radius: 50%;
  background-color: #fff;
  width: 41px;
  height: 41px;
  display: inline-block;
  text-align: center;
  border: 1px solid #0079c2;
  margin-left: 12px;
}

.active .notify a:hover {
  border: 1px solid #fff;
  background: #0079c2 !important;
  text-decoration: none !important;
}

.active .notify a::before {
  content: '\\f0f3';
  font-size: 27px;
  color: #0079c2;
  font-family: FontAwesome;
  font-weight: normal;
  position: relative;
}

.active .notify a:hover:before {
  color: #fff;
}

.active .user a {
  border-radius: 50%;
  background-color: #fff;
  width: 41px;
  height: 41px;
  display: inline-block;
  text-align: center;
  border: 1px solid #0079c2;
  margin-left: 12px;
}

.active .user a:hover {
  border: 1px solid #fff;
  background: #0079c2 !important;
  text-decoration: none !important;
}

.active .user a::before {
  /* content: '\\f007'; */
  font-size: 27px;
  color: #0079c2;
  /* font-family: FontAwesome; */
  font-weight: normal;
  position: relative;
}

.active .user a:hover:before {
  color: #fff;
}

.public-navbar .pageTitle {
  width: 100%;
}

.flex {
  display: flex;
  margin-bottom: 0px;
}

.menuProfileIcon {
  font-size: 24px;
  color: white;
}

.menuProfileIcon:hover {
  font-size: 24px;
  color: #0079c2 !important;
}
`, "",{"version":3,"sources":["webpack://./client/header/header.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,wCAAwC;EACxC,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,OAAO;EACP,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,yCAAyC;EACzC,sCAAsC;EACtC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,yCAAyC;EACzC,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,YAAY;IACZ,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA,gDAAgD;;AAEhD;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B","sourcesContent":[".header-container {\n  position: relative;\n}\n\n.header-container .navtlbar {\n  display: flex;\n  justify-content: space-between;\n  flex-flow: row nowrap;\n  align-items: center;\n}\n\n.header-container .pageTitle-new {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n}\n\n.hamHeader a {\n  text-decoration: none !important;\n}\n\n.menuHam {\n  width: 30px;\n  display: flex;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: all 0.5s ease-in-out;\n  -moz-transition: all 0.5s ease-in-out;\n  -o-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  color: #0078ab;\n  cursor: pointer;\n  height: 22px;\n}\n\n.menuHam span {\n  opacity: 1;\n  left: 0;\n  cursor: pointer;\n  border-radius: 3px;\n  height: 3px;\n  width: 100%;\n  background-color: #0078ab;\n  position: absolute;\n  display: block;\n  content: '';\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: all 0.25s ease-in-out;\n  -moz-transition: all 0.25s ease-in-out;\n  -o-transition: all 0.25s ease-in-out;\n  transition: all 0.25s ease-in-out;\n}\n\n.active.menuHam span {\n  background-color: #fff;\n}\n\n.menuHam span:nth-child(1) {\n  top: 0px;\n}\n\n.menuHam span:nth-child(2) {\n  top: 9px;\n}\n\n.menuHam span:nth-child(3) {\n  top: 18px;\n}\n\n.menuHam.active span:nth-child(1) {\n  top: 7px;\n  -webkit-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  -o-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n\n.menuHam.active span:nth-child(2) {\n  opacity: 0;\n  right: -30px;\n}\n\n.menuHam.active span:nth-child(3) {\n  top: 7px;\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.menuItemDisable {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.navbar-nav > li > a {\n  line-height: 50px;\n}\n\n.pageTitle.active {\n  display: none;\n}\n\n.navbar-fixed-top {\n  z-index: 999;\n  background: #fff;\n  height: 100px;\n  width: 100%;\n}\n\n.navbar-fixed-top.active {\n  z-index: 9999;\n  color: #fff;\n  background-color: #087dc3;\n  transition: background-color 0.2s ease;\n  height: 100px;\n  width: 100%;\n}\n\n.navbar-collapse.collapse {\n  display: block;\n}\n\n.navbar-brand {\n  float: left;\n  height: 50px;\n  font-size: 18px;\n  margin-left: 89px;\n  margin-top: 5px;\n  line-height: 20px;\n}\n\n.sidenav.collapseMenu {\n  width: 0;\n  transition: background-color 0.2s ease;\n  z-index: 99999;\n}\n\n.ptbBody .ptbBkground.backdrop {\n  z-index: 10000;\n}\n\n.sidenav.expandMenu {\n  width: 100%;\n  display: flex;\n  height: calc(100vh - 85px);\n  background-color: rgba(0, 121, 194, 0.97);\n  transition: background-color 0.2s ease;\n  visibility: visible;\n  overflow-y: auto;\n}\n\n.sidenav {\n  height: 100%;\n  position: fixed;\n  z-index: 9999;\n  top: 100px;\n  padding-top: 50px;\n}\n\n.menuTitle {\n  margin-top: -11px;\n  margin-left: 45px;\n  font-size: 28px;\n  color: #0078ab;\n  font-family: 'Open Sans', sans-serif;\n}\n\n.active.menuHam .menuTitle {\n  display: inline;\n  margin-left: 48px;\n  color: #fff;\n}\n\n.sidenav .nav_btn_conatiner a {\n  color: #fff;\n  font-size: 20px;\n  display: block;\n  text-decoration: none;\n  -webkit-transition: 0.03ms;\n  -moz-transition: 0.03ms;\n  transition: 0.03ms;\n  cursor: pointer;\n}\n\n.sidenav .nav_btn_conatiner a i {\n  width: 60px;\n  height: 65px;\n  display: block;\n  margin: 40px auto 0px;\n}\n\n.header-container .navbar .userInfo {\n  display: none;\n}\n\n.pageTitle {\n  text-align: center;\n  width: 33.33333333333333%;\n  float: left;\n}\n\n.menuHam-new {\n  display: none;\n}\n.new-nav {\n  border: 0;\n  box-shadow: none;\n  height: 120px;\n}\n\n.ant-bp-pagetitle {\n  font-family: 'Open Sans';\n  font-weight: normal;\n  font-size: 32px;\n  color: #0079c2;\n  position: relative;\n  margin-bottom: 0px;\n  cursor: pointer;\n}\n\n.pageTitle img {\n  width: 130px;\n}\n\n.active .pageTitle img {\n  visibility: hidden;\n}\n.navtkbar {\n  display: none;\n}\n\n.navtkbar {\n  float: left;\n  width: 33.33333333333333%;\n}\n\n.navtkbar ul {\n  float: right;\n  margin: 0;\n}\n\n.notify {\n  float: left;\n  list-style-type: none;\n}\n.notifyMsg {\n  white-space: nowrap;\n  width: 204px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.notify .greetingMsg {\n  font-size: 1.125em;\n  text-transform: capitalize;\n  top: 8px;\n  position: relative;\n  font-weight: normal;\n}\n.notify h5 {\n  text-align: right;\n  font-weight: 600;\n  margin-top: 0.4em;\n}\n\n.notify a {\n  border-radius: 50%;\n  background-color: #0079c2;\n  width: 41px;\n  height: 41px;\n  display: inline-block;\n  text-align: center;\n  border: 1px solid #0079c2;\n  margin-left: 12px;\n}\n\n.notify a:hover {\n  border: 1px solid #0079c2;\n  background: #ffffff !important;\n  text-decoration: none !important;\n}\n\n.notify a::before {\n  content: '\\f0f3';\n  font-size: 27px;\n  color: #ffffff;\n  font-family: FontAwesome;\n  font-weight: normal;\n  position: relative;\n}\n\n.notify a:hover::before {\n  color: #0079c2;\n}\n\n.notify .fa {\n  color: #fe5e3c;\n  font-size: 15px;\n  position: absolute;\n  margin: 5px -12px;\n}\n\n.user {\n  float: left;\n  list-style-type: none;\n}\n\n.user a {\n  border-radius: 50%;\n  background-color: #0079c2;\n  width: 41px;\n  height: 41px;\n  display: inline-block;\n  text-align: center;\n  border: 1px solid #0079c2;\n  margin-left: 12px;\n}\n\n.user a:hover {\n  border: 1px solid #0079c2;\n  background: #ffffff !important;\n  text-decoration: none !important;\n}\n\n.user a::before {\n  /* content: '\\f007'; */\n  font-size: 27px;\n  color: #ffffff;\n  /* font-family: FontAwesome; */\n  font-weight: normal;\n  position: relative;\n}\n\n.user a:hover:before {\n  color: #0079c2;\n}\n\n.mobileSearch {\n  float: left;\n  list-style-type: none;\n}\n\n.mobileSearch a {\n  border-radius: 50%;\n  background-color: #0079c2;\n  width: 41px;\n  height: 41px;\n  display: inline-block;\n  text-align: center;\n  border: 1px solid #0079c2;\n  margin-left: 12px;\n}\n\n.mobileSearch a:hover {\n  border: 1px solid #0079c2;\n  background: #ffffff !important;\n  text-decoration: none !important;\n}\n\n.mobileSearch a::before {\n  content: '\\f002';\n  font-size: 27px;\n  color: #ffffff;\n  font-family: FontAwesome;\n  font-weight: normal;\n  position: relative;\n}\n\n.mobileSearch a:hover:before {\n  color: #0079c2;\n}\n\n@media screen and (max-width: 1177px) {\n  .navbar {\n    padding: 20px 40px 0px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .navbar {\n    padding: 20px 0px 0 1px;\n  }\n  .new-nav {\n    padding: 20px 40px 0px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .sidenav {\n    padding: 0px;\n  }\n  .active .navtkbar {\n    display: block;\n  }\n  .menuTitle {\n    display: none;\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 801px) {\n  .menuTitle {\n    display: none;\n  }\n}\n\n@media screen and (min-width: 801px) {\n  .navtkbar {\n    display: block;\n  }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n  .active.menuHam .menuTitle {\n    display: inline;\n    margin-left: 48px;\n    color: #fff;\n  }\n  .pageTitle img {\n    width: 130px;\n    transition: width 2s;\n  }\n}\n\n@media screen and (max-width: 599px) {\n  .menuHam-new {\n    display: block;\n    margin-right: 12px;\n  }\n  .active.menuHam-new span {\n    background-color: #0079c2;\n  }\n  #app {\n    top: 100px;\n  }\n  .new-nav {\n    padding: 30px 10px 0px;\n    height: 100px;\n  }\n  .greet {\n    margin-bottom: 2px;\n  }\n}\n\n@media only screen and (min-device-width: 600px) and (max-device-width: 768px) {\n  .navtkbar {\n    width: 66.3333333333333%;\n  }\n  .active.menuHam .menuTitle {\n    display: none;\n  }\n}\n\n@media only screen and (min-device-width: 525px) and (max-device-width: 600px) {\n  .active .pageTitle {\n    display: none;\n  }\n  .navtkbar {\n    width: 66.3333333333333%;\n    float: right;\n  }\n  .active.menuHam .menuTitle {\n    display: none;\n  }\n}\n\n@media only screen and (min-width: 525px) and (max-width: 875px) {\n  .active .pageTitle {\n    display: none;\n  }\n  .navtkbar {\n    width: 38.3333333333333%;\n    float: right;\n  }\n  .active.menuHam .menuTitle {\n    display: none;\n  }\n  .pageTitle {\n    width: auto;\n  }\n  .ant-bp-pagetitle {\n    font-size: 32px;\n  }\n}\n\n@media screen and (min-width: 375px) and (max-width: 525px) {\n  .active .pageTitle {\n    display: none;\n  }\n  .navtkbar {\n    width: 66.3333333333333%;\n    float: right;\n  }\n  .notify .greetingMsg {\n    font-size: 1em;\n  }\n  .menuTitle {\n    display: none;\n  }\n  .active.menuHam .menuTitle {\n    display: none;\n  }\n  .pageTitle {\n    width: auto;\n  }\n  .ant-bp-pagetitle {\n    font-size: 24px;\n    position: relative;\n  }\n}\n\n@media screen and (max-width: 375px) {\n  .active .pageTitle {\n    display: none;\n  }\n  .notify .greetingMsg {\n    font-size: 12px;\n  }\n  .notify h5 {\n    font-size: 0.9em;\n  }\n  .navtkbar {\n    width: 66.3333333333333%;\n    float: right;\n  }\n  .menuTitle {\n    display: none;\n  }\n  .active.menuHam .menuTitle {\n    display: none;\n  }\n  .pageTitle {\n    width: auto;\n  }\n  .ant-bp-pagetitle {\n    font-size: 24px;\n    position: relative;\n  }\n  .notifyMsg {\n    width: 116px;\n  }\n}\n@media screen and (max-width: 425px) {\n  .small-icons a {\n    width: 30px;\n    height: 30px;\n  }\n  .small-icons a::before {\n    font-size: 19px;\n  }\n}\n\n/* Header Icons styles when the menu is active */\n\n.active .notify a {\n  border-radius: 50%;\n  background-color: #fff;\n  width: 41px;\n  height: 41px;\n  display: inline-block;\n  text-align: center;\n  border: 1px solid #0079c2;\n  margin-left: 12px;\n}\n\n.active .notify a:hover {\n  border: 1px solid #fff;\n  background: #0079c2 !important;\n  text-decoration: none !important;\n}\n\n.active .notify a::before {\n  content: '\\f0f3';\n  font-size: 27px;\n  color: #0079c2;\n  font-family: FontAwesome;\n  font-weight: normal;\n  position: relative;\n}\n\n.active .notify a:hover:before {\n  color: #fff;\n}\n\n.active .user a {\n  border-radius: 50%;\n  background-color: #fff;\n  width: 41px;\n  height: 41px;\n  display: inline-block;\n  text-align: center;\n  border: 1px solid #0079c2;\n  margin-left: 12px;\n}\n\n.active .user a:hover {\n  border: 1px solid #fff;\n  background: #0079c2 !important;\n  text-decoration: none !important;\n}\n\n.active .user a::before {\n  /* content: '\\f007'; */\n  font-size: 27px;\n  color: #0079c2;\n  /* font-family: FontAwesome; */\n  font-weight: normal;\n  position: relative;\n}\n\n.active .user a:hover:before {\n  color: #fff;\n}\n\n.public-navbar .pageTitle {\n  width: 100%;\n}\n\n.flex {\n  display: flex;\n  margin-bottom: 0px;\n}\n\n.menuProfileIcon {\n  font-size: 24px;\n  color: white;\n}\n\n.menuProfileIcon:hover {\n  font-size: 24px;\n  color: #0079c2 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
